import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { DOCUMENT } from "@angular/platform-browser";
import { Router } from '@angular/router';

import { Payee, AccessToken, PayeeSubmission, PayeeService, Service } from '../../shared/sdk/models';
import { Declaration } from '../../shared/app/models/MerchantApplication';
import { PayeeApi, ServiceApi } from '../../shared/sdk/services';
import { GlobalEventsManager } from '../../events-manager.component'

@Component({
  selector: 'consent',
  templateUrl: 'consent.component.html',
  styleUrls: ['../application.css'],
  providers: [
    { provide: 'Window',  useValue: window }
  ]
})

export class ConsentComponent implements OnInit {

  declaration: boolean = false;
  public valid: boolean = true;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private userApi: PayeeApi,
    private serviceApi: ServiceApi,
    private eventsManager: GlobalEventsManager
  ) { 
  }

  // Initialisation
  ngOnInit() { 
    this.eventsManager.loaded(true);
    this.userApi.findById(this.userApi.getCurrentId()).subscribe(
      res => {
        let payee = <Payee> res;
        if (payee.pre_form_declaration) {
          this.eventsManager.loaded(false);
          this.router.navigate(['/form']);
        }
      }, 
      err => {
        console.log(err)
      }
    )
  }

  // Validation
  validate() {

    this.valid = true;

    let elements = this.document.getElementsByName('declaration')[0].getElementsByClassName('ng-invalid');

    if (this.valid && elements.length == 0) {
      this.userApi.patchAttributes(this.userApi.getCurrentId(), {'pre_form_declaration': this.declaration}).subscribe(
        res => {
          this.eventsManager.loaded(false);
          this.router.navigate(['/form']);
        },
        err => {
          this.eventsManager.showPopUp("An error has occured. Please try again later.");
        }
      )
    } else {

      this.valid = false;

      if (elements.length != 0) {
        console.log(elements[0]);
      }
      this.eventsManager.showPopUp("The declaration of consent must be checked to proceed with your application.");
    // this.router.navigate(['/submit']);
    } 
  }

  change(page) {
    if (page == 'Services') {
          this.router.navigate(['/chooseBusiness']);
          return;
        }
   }

  // Scrolling
  scrollToTop() {
    //window.scroll(0, 0);
    //this.document.body.getElementsByClassName('scroll_declaration')[0].scrollTop = 0;
  }

}
